const cartGetters = {

  getCart: state => {
    return state.search_event
  }
}

export { cartGetters }
